(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
	class LocalizationForm extends HTMLElement {
		constructor() {
			super();
			this.elements = {
				input: this.querySelector(
					'input[name="locale_code"], input[name="country_code"]'
				),
				button: this.querySelector('button'),
				panel: this.querySelector('ul'),
			};
			this.elements.button.addEventListener(
				'click',
				this.openSelector.bind(this)
			);
			this.elements.button.addEventListener(
				'focusout',
				this.closeSelector.bind(this)
			);
			this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

			this.querySelectorAll('a').forEach((item) =>
				item.addEventListener('click', this.onItemClick.bind(this))
			);
		}

		hidePanel() {
			this.elements.button.setAttribute('aria-expanded', 'false');
			this.elements.panel.setAttribute('hidden', true);
		}

		onContainerKeyUp(event) {
			if (event.code.toUpperCase() !== 'ESCAPE') return;

			this.hidePanel();
			this.elements.button.focus();
		}

		onItemClick(event) {
			event.preventDefault();
			this.elements.input.value = event.currentTarget.dataset.value;
			this.querySelector('form')?.submit();
		}

		openSelector() {
			this.elements.button.focus();
			this.elements.panel.toggleAttribute('hidden');
			this.elements.button.setAttribute(
				'aria-expanded',
				(
					this.elements.button.getAttribute('aria-expanded') === 'false'
				).toString()
			);
		}

		closeSelector(event) {
			const shouldClose =
				event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
			if (event.relatedTarget === null || shouldClose) {
				this.hidePanel();
			}
		}
	}

	customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
	class StickyHeader extends HTMLElement {
		constructor() {
		super();
	}

	connectedCallback() {
		this.header = document.querySelector('.shopify-section-header');
		this.headerOverlay = document.querySelector('.header-overlay');
		this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
		this.headerBounds = {};
		this.currentScrollTop = 0;
		this.preventReveal = false;

		if (this.headerIsAlwaysSticky) {
			this.header.classList.add('shopify-section-header-sticky','always-fixed');
			if (this.headerOverlay) {
				this.headerOverlay.classList.add('color-background-1');
				this.headerOverlay.classList.remove('color-inverse');
			}
		};

		this.onScrollHandler = this.onScroll.bind(this);
		this.hideHeaderOnScrollUp = () => this.preventReveal = true;
		this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.addEventListener('scroll', this.onScrollHandler, false);

		this.createObserver();
	}

	disconnectedCallback() {
		this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.removeEventListener('scroll', this.onScrollHandler);
	}

	createObserver() {
		let observer = new IntersectionObserver((entries, observer) => {
			this.headerBounds = entries[0].intersectionRect;
			observer.disconnect();
		});

		observer.observe(this.header);
	}

	onScroll() {
		const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

		if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
			if (this.preventHide) return;
			requestAnimationFrame(this.hide.bind(this));
			} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
			if (!this.preventReveal) {
			requestAnimationFrame(this.reveal.bind(this));
			}else {
			window.clearTimeout(this.isScrolling);

			this.isScrolling = setTimeout(() => {
			this.preventReveal = false;
			}, 66);

			requestAnimationFrame(this.hide.bind(this));
		}
		} else if (scrollTop <= this.headerBounds.top) {
			requestAnimationFrame(this.reset.bind(this));
		}

		this.currentScrollTop = scrollTop;
	}

	hide() {
		if (document.querySelector(".search-modal.active")) return;
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
		if (this.headerOverlay) {
			this.headerOverlay.classList.add('color-background-1');
		}
	}

	reveal() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.add('shopify-section-header-sticky', 'animate');
		this.header.classList.remove('shopify-section-header-hidden','color-inverse');
		if (this.headerOverlay) {
			this.headerOverlay.classList.add('color-background-1');
			this.headerOverlay.classList.remove('color-inverse');
		}
	}

	reset() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
		if (this.headerOverlay) {
			this.headerOverlay.classList.remove('color-background-1');
			this.headerOverlay.classList.add('color-inverse');
		}
	}

	//closeMenuDisclosure() {
	//	this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
	//	this.disclosures.forEach(disclosure => disclosure.close());
	//}

	}

	customElements.define('sticky-header', StickyHeader);	
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();
      this.addEventListener(
        'input',
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        }, 300)
      );
    }
  }
  customElements.define('cart-note', CartNote);

  // Akceptacja regulaminu bez nadpisywania natywnego stanu pustego koszyka.
  (function(){
    if (window.__ROBIN_CART_LEGAL_INIT__) return;
    window.__ROBIN_CART_LEGAL_INIT__ = true;

    function initCartLegal(){
      const terms = document.getElementById('termsAccepted');
      const errorEl = document.getElementById('cart-legal-error');
      const legalBox = document.getElementById('cart-legal');
      const checkoutBtn = document.querySelector('button[name="checkout"][form="cart"]');
      const dynamicBox = document.querySelector('.cart__footer-dynamic-checkout');
      const cartForm = document.getElementById('cart');

      if (!terms || !legalBox || !checkoutBtn || !cartForm) return;

      function setCheckoutState(){
        const allowed = terms.checked;
        checkoutBtn.classList.toggle('is-disabled', !allowed);
        checkoutBtn.setAttribute('aria-disabled', allowed ? 'false' : 'true');

        if (dynamicBox) {
          dynamicBox.classList.toggle('is-disabled', !allowed);
        }

        if (allowed) legalBox.classList.remove('cart-legal--error');
      }

      function showError(){
        legalBox.classList.add('cart-legal--error');
        terms.focus();
        if (errorEl) {
          errorEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }

      terms.addEventListener('change', setCheckoutState);

      checkoutBtn.addEventListener('click', function(event){
        if (terms.checked) return;
        event.preventDefault();
        showError();
      });

      cartForm.addEventListener('submit', function(event){
        if (terms.checked) return;
        event.preventDefault();
        showError();
      });

      setCheckoutState();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initCartLegal, { once: true });
    } else {
      initCartLegal();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
class ProductModal extends ModalDialog {
  constructor() { super(); }
  hide() { super.hide(); window.pauseAllMedia(); }
  show(opener) { super.show(opener); this.showActiveMedia(); }
  showActiveMedia() {
    this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((el)=>{ el.classList.remove('active'); });
    const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
    if (activeMedia) { activeMedia.classList.add('active'); activeMedia.scrollIntoView(); }
    if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
      activeMedia.loadContent();
  }
}

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      fetch(this.dataset.url)
        .then(r => r.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations--single');
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }
        })
        .catch(e => console.error(e));
    }
    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
  }
}

customElements.define('product-modal', ProductModal);
customElements.define('product-recommendations--single', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moje-seo"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const content = document.querySelector('.robin-seo__content');
    const button = document.querySelector('[data-action="toggle-seo-content"]');
    const collapsedHeight = 180;

    if (!content || !button) return;

    if (content.textContent.trim() === '') {
      content.closest('.robin-seo').style.display = 'none';
      return;
    }

    content.style.maxHeight = collapsedHeight + 'px';

    button.addEventListener('click', () => {
      const isCollapsed = content.classList.contains('collapsed');

      if (isCollapsed) {
        content.style.maxHeight = content.scrollHeight + 'px';
        content.classList.remove('collapsed');
        button.textContent = button.dataset.less;
      } else {
        content.style.maxHeight = content.scrollHeight + 'px';
        requestAnimationFrame(() => {
          content.style.maxHeight = collapsedHeight + 'px';
          content.classList.add('collapsed');
          button.textContent = button.dataset.more;
        });
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
	class ProductRecommendations extends HTMLElement {
		constructor() {
			super();

			const handleIntersection = (entries, observer) => {
				if (!entries[0].isIntersecting) return;
				observer.unobserve(this);

				fetch(this.dataset.url)
					.then((response) => response.text())
					.then((text) => {
						const html = document.createElement('div');
						html.innerHTML = text;
						const recommendations = html.querySelector(
							'product-recommendations'
						);
						if (recommendations && recommendations.innerHTML.trim().length) {
							this.innerHTML = recommendations.innerHTML;
						}
					})
					.catch((e) => {
						console.error(e);
					});
			};

			new IntersectionObserver(handleIntersection.bind(this), {
				rootMargin: '0px 0px 200px 0px',
			}).observe(this);
		}
	}

	customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pytania"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".faq-category-header").forEach((header) => {
    header.addEventListener("click", function () {
      const parent = this.closest(".faq-category");
      const content = parent.querySelector(".faq-questions");

      const isOpen = parent.classList.contains("open");

      // Zamknij inne sekcje
      document.querySelectorAll(".faq-category").forEach((cat) => {
        cat.classList.remove("open");
        cat.querySelector(".faq-questions").style.display = "none";
      });

      // Jeśli nie była otwarta, otwórz
      if (!isOpen) {
        parent.classList.add("open");
        content.style.display = "block";
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["robin-hero"] && !Shopify.designMode) return;
  try {
    
const swiper = new Swiper('.robin-hero.swiper', {
  loop: true,
  speed: 3000,
  autoplay: {
    delay: 10000,
    disableOnInteraction: true,
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true
  },
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["robin-reviews"] && !Shopify.designMode) return;
  try {
    
  const swiper = new Swiper('.robin-reviews.swiper', {
    slidesPerView: 1,
    spaceBetween: 24,
    loop: true,
    speed: 3000,
    autoplay: {
      delay: 10000,
      disableOnInteraction: true,
    },
    breakpoints: {
      1024: {
        slidesPerView: 2,
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["robin-seo"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const content = document.querySelector('.robin-seo__content');
    const button = document.querySelector('[data-action="toggle-seo-content"]');
    const collapsedHeight = 180;

    if (!content || !button) return;

    // Ustaw domyślny max-height
    content.style.maxHeight = collapsedHeight + 'px';

    button.addEventListener('click', () => {
      const isCollapsed = content.classList.contains('collapsed');

      if (isCollapsed) {
        // rozwijanie
        content.style.maxHeight = content.scrollHeight + 'px';
        content.classList.remove('collapsed');
        button.textContent = button.dataset.less;
      } else {
        // zwijanie
        content.style.maxHeight = content.scrollHeight + 'px'; // potrzebne do płynnego przejścia
        requestAnimationFrame(() => {
          content.style.maxHeight = collapsedHeight + 'px';
          content.classList.add('collapsed');
          button.textContent = button.dataset.more;
        });
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-circle-reveal"] && !Shopify.designMode) return;
  try {
    
(function(){
  const secs = document.querySelectorAll('.ri-cr');
  if(!secs.length) return;

  const clamp = (n,min,max)=>Math.min(Math.max(n,min),max);

  function recalc(){
    const vh = window.innerHeight || 800;

    secs.forEach(sec=>{
      const pin   = sec.querySelector('.ri-cr__pin');
      const stage = sec.querySelector('.ri-cr__stage');
      if(!pin || !stage) return;

      const isMobile = window.matchMedia('(max-width: 749px)').matches;
      sec._isMobile   = isMobile;
      sec._mobileNoPin = (sec.dataset.nopin === 'true' || sec.dataset.nopin === '1');

      /* Desktop: sticky pin; Mobile: no-pin */
      const pinLen  = parseInt(sec.dataset.pin  || '220', 10); // vh
      const pinLenM = parseInt(sec.dataset.pinm || '130', 10); // vh gdy no-pin OFF
      if(isMobile){
        pin.style.setProperty('--pin-h', (sec._mobileNoPin ? 'auto' : (pinLenM + 'vh')));
      }else{
        pin.style.setProperty('--pin-h', pinLen + 'vh');
      }

      /* Rogi */
      const br = parseInt(sec.dataset.br || '24', 10);
      stage.style.setProperty('--br', br + 'px');

      /* Dopasowanie obrazu */
      const fit = (sec.dataset.fit || 'contain');
      if(fit === 'cover_top'){
        stage.style.setProperty('--fit', 'cover');
        stage.style.setProperty('--pos', 'top center');
      }else{
        stage.style.setProperty('--fit', 'contain');
        stage.style.setProperty('--pos', 'center center');
      }

      /* Start i udział „pre” (desktop) */
      const preStart = clamp((parseInt(sec.dataset.prestart || '40', 10))/100, 0, 0.9);
      sec._preStartY = vh * preStart;
      sec._preShare  = clamp((parseInt(sec.dataset.preshare || '25', 10))/100, 0, 0.9);

      /* Mobile: scena height + max szerokość tekstu */
      const mobH = parseInt(sec.dataset.mobileh || '56', 10); // vh
      stage.style.setProperty('--stage-h-m', mobH + 'vh');

      const textMax = parseInt(sec.dataset.textmax || '960', 10);
      stage.style.setProperty('--text-max', textMax + 'px');
    });

    update();
  }

  function update(){
    const vh = window.innerHeight || 800;

    secs.forEach(sec=>{
      const pin   = sec.querySelector('.ri-cr__pin');
      const stage = sec.querySelector('.ri-cr__stage');
      if(!pin || !stage) return;

      const minR = parseInt(sec.dataset.minr || '140', 10);

      let p_total = 0;

      if(sec._isMobile && sec._mobileNoPin){
        /* === MOBILE: NO-PIN === */
        const rs = stage.getBoundingClientRect();
        // start wcześniej (niżej na ekranie), koniec też wcześniej
        const startY = vh * 0.45;          // było 0.60
        const endY   = -rs.height * 0.05;  // było -0.20
        p_total = clamp((startY - rs.top) / (startY - endY), 0, 1);
      }else{
        /* === DESKTOP (sticky) lub mobile bez no-pin === */
        const rect = pin.getBoundingClientRect();
        const startY   = sec._preStartY || (vh*0.4);
        const preShare = sec._preShare ?? 0.25;

        let p_pre = clamp((startY - rect.top) / Math.max(startY,1), 0, 1);

        const denom = Math.max(rect.height - vh, 1);
        let p_pin = 0;
        if(rect.top <= 0 && rect.bottom >= vh){
          p_pin = clamp( (-rect.top) / denom, 0, 1 );
        } else if(rect.bottom < vh){
          p_pin = 1;
        } else {
          p_pin = 0;
        }

        p_total = clamp( p_pre * preShare + p_pin * (1 - preShare), 0, 1 );
      }

      /* Promień koła i fade tekstu */
      const s = stage.getBoundingClientRect();
      const maxR = Math.hypot(s.width * 0.5, s.height * 0.5) + 24;
      const eased = Math.pow(p_total, 0.95);
      const r = minR + (maxR - minR) * eased;
      stage.style.setProperty('--r', r + 'px');

      // Fade-out (mobile jeszcze szybciej)
      const isM = sec._isMobile === true;
      const fadeStart = isM ? 0.65 : 0.85;  // start wygaszania
      const fadeEnd   = isM ? 0.78 : 1.00;  // koniec wygaszania

      let textO = 1;
      if (p_total >= fadeStart){
        textO = clamp(1 - (p_total - fadeStart) / Math.max(fadeEnd - fadeStart, 0.0001), 0, 1);
      }
      // twarde ucięcie, żeby nie „szarzało”
      if (isM && textO < 0.15) textO = 0;

      stage.style.setProperty('--text-o', textO.toFixed(3));
    });
  }

  recalc();
  window.addEventListener('resize', recalc, {passive:true});
  window.addEventListener('scroll', update, {passive:true});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-tech-specs"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.addEventListener('click', function(e){
    const zoomBtn = e.target.closest('.ri-zoom');
    if(zoomBtn){
      const wrap = zoomBtn.closest('.ri-techspecs__imagewrap');
      const dlg = wrap && wrap.querySelector('dialog.ri-dialog');
      if(dlg && dlg.showModal){ dlg.showModal(); }
    }
    const closeBtn = e.target.closest('[data-close-dialog]');
    if(closeBtn){
      const dlg = closeBtn.closest('dialog.ri-dialog');
      if(dlg && dlg.close){ dlg.close(); }
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
